import api from "../../index";

export const GetAllBankDetailsApi = () => api.get('BankDetails/Get-All-Bank-Details');
export const AddUpdateBankDetailsApi = (data) => api.post('BankDetails/Add-Update-Bank-Details', data);
export const ActiveInactiveBankDetailApi = (data) => api.put('BankDetails/Active-Inactive-Bank-Detail', data);
export const DeleteBankDetailApi = (bankDetailId) => api.delete(`BankDetails/Delete-Bank-Detail/${bankDetailId}`);